import { useEffect, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";

const UpdateForm = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, forms = [], formId, apiUrl }) => {
  const [initialValues, setInitialValues] = useState({});
  const [validationSchema, setValidationSchema] = useState(null);
  const apiCall = useApiCall();

  useEffect(() => {
    if (!forms?.length) return;

    const values = {};
    const schemaFields = {};

    forms.forEach((field) => {

      values[field.field_key] = field?.value || "";

      schemaFields[field.field_key] = yup
        .string("This Field is Required")
        .required("This Field is Required");
    });

    setInitialValues(values);
    setValidationSchema(yup.object().shape(schemaFields));
  }, [forms]);

  const formik = useFormik({
    enableReinitialize: true, // 👈 important when values/schema are built dynamically
    initialValues,
    validationSchema,
    onSubmit: async (values) => {

      let apiData = {
        "form_key": formId,
        ...values
      }

      try {
        let apiRes = await apiCall({ method: "post", url: apiUrl, data: apiData })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
        // onClose()
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }

    },
  });


  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal}`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>Update Form</h4>

          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea}`}>
                {forms?.map((eachField, i) => {
                  return(
                    <>
                      {eachField?.type == "dropdown" ?
                        <div key={i} className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                          <label htmlFor="">{eachField?.label}</label>
                          <select name={eachField?.field_key} value={formik.values[eachField?.field_key]} onChange={formik.handleChange}>
                            <option value="" disabled selected>-- {eachField?.label} --</option>
                            {eachField?.options?.map((eachOpt, index) => (
                              <option value={eachOpt?.value} key={index}>{eachOpt?.label}</option>
                            ))}
                          </select>
                          {
                            (formik.touched[eachField?.field_key] && Boolean(formik.errors[eachField?.field_key])) ?
                              <span style={{ color: "red" }} className='ps-1'>{formik.touched[eachField?.field_key] && formik.errors[eachField?.field_key]}</span>
                              :
                              null
                          }
                        </div>
                        :
                        (eachField?.type == "textarea") ?
                        <div key={i} className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                          <label htmlFor="">{eachField?.label}</label>
                          <textarea name={eachField?.field_key} value={formik.values[eachField?.field_key]} onChange={formik.handleChange} placeholder={eachField?.label}></textarea>
                          {
                            (formik.touched[eachField?.field_key] && Boolean(formik.errors[eachField?.field_key])) ?
                              <span style={{ color: "red" }} className='ps-1'>{formik.touched[eachField?.field_key] && formik.errors[eachField?.field_key]}</span>
                              :
                              null
                          }
                        </div>
                        :
                        <div key={i} className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                          <label htmlFor="">{eachField?.label}</label>
                          {/* <input type="date" placeholder='Type Here' /> */}
                          <input
                            type={eachField?.type || "text"}
                            name={eachField?.field_key}
                            value={formik.values[eachField?.field_key]}
                            onChange={formik.handleChange}
                            placeholder={eachField?.label}
                          />
                          {
                            (formik.touched[eachField?.field_key] && Boolean(formik.errors[eachField?.field_key])) ?
                              <span style={{ color: "red" }} className='ps-1'>{formik.touched[eachField?.field_key] && formik.errors[eachField?.field_key]}</span>
                              :
                              null
                          }
                        </div>
                      }
                    </>
                  )
                })}
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default UpdateForm